
import { UsuariosDataTable } from './dataTable/UsuariosDataTable.jsx'
import { Header } from './header/Header'
import { HeaderMain } from './responsiveHeader/HeaderMain'
import { SearchContainer } from './searchContainer/SearchContainer'
import { ActionButtons } from './buttonsContainer/ActionButtons'
import { mockUsuarios } from '../../../assets/UsuariosMocks.js'
import { Outlet } from 'react-router-dom'
import './secondaryContainer.css'


export const SecondaryContainer = () => {

    let users = mockUsuarios


    return (
        <div className="col-12 col-md-11 col-lg-10 cont-secundario secondary-container-style">

            <Header />


            <main className="main">


                <Outlet/>

               

                {/* <HeaderMain /> */}

            </main>

        </div>
    )
}
